import { ColorTypes } from "@omegagrid/core";
import { msg } from "@omegagrid/localize";
import { FormAdapter, FormAlert, FormContainerOptions, FormControlType, FormValues } from '@omegagrid/form';
import rp from '@reporting/rp-app-host';
import { StatementDefinition } from '@reporting/rp-types/definition';

export class FinAccountsDeleteFormAdapter extends FormAdapter {

	constructor(
		private statement: StatementDefinition,
		private year: number = null,
	) { super() }

	getColumns() {
		return [
			{width: 120},
			{width: null},
		];
	}

	async getControls() {
		const years = await rp.ms('analytics').get<number[]>('years/all');
		return [
			{row: 0, col: 0, type: FormControlType.Label, value: msg('Year'), for: 'year'},
			{row: 0, col: 1, type: FormControlType.List, key: 'year', required: true, value: this.year, content: {
				sourceData: years.map(year => ({k: year, v: year})),
				options: {selectMode: 'single', autoClose: true}
			}},
		];
	}

	getOptions(): FormContainerOptions {
		return {
			caption: null,
			buttonsPosition: 'bottom',
			alertsPosition: 'bottom',
			buttons: [{ key: "save", text: msg("Delete"), color: ColorTypes.Red }, "close"]
		};
	}

	async save(values: Map<string|number, FormValues>): Promise<boolean|FormAlert[]> {
		const formValues = values.get(0);
		await rp.ms('definition').delete('statementAccounts', {
			idStatement: this.statement.id_statement,
			year: formValues.year,
		});
		return true;
	}

};
